import { Component, OnInit, ViewChild, AfterViewInit  } from '@angular/core'
import { locale as en } from '../i18n/en'
import { locale as fr } from '../i18n/fr'
import { locale as de } from '../i18n/de'
import { locale as pt } from '../i18n/pt'
import { CoreTranslationService } from '@core/services/translation.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CoreConfigService } from '@core/services/config.service';
import { ColumnMode, DatatableComponent, id } from '@swimlane/ngx-datatable';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'
import { ApiService } from 'app/main/services/Api/api.service'
import { HttpErrorResponse } from '@angular/common/http'
import { ToastService } from 'app/main/services/Toast/toast.service'
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms'
import { ContentHeader } from '../ContentHeader'
import { ApiResponse } from '../ApiResponse'
import { AdminRow } from './AdminRow'
import { AdminUserDto } from './AdminUserDto'
import { AdminDetailDto } from './AdminDetailDto'

@Component({
  selector: 'app-admins',
  templateUrl: './admins.component.html',
  styleUrls: ['./admins.component.scss']
})
export class AdminsComponent implements OnInit {
  switchUserAccessStateForm: FormGroup
  addAdminForm: FormGroup
  public contentHeader!: ContentHeader;
 /**
   *
   * @param {CoreTranslationService} _coreTranslationService
   */
  constructor(private _coreTranslationService: CoreTranslationService,private modalService: NgbModal,
    private api: ApiService,public toastService: ToastService,private formBuilder: FormBuilder) {
    this._coreTranslationService.translate(en, fr, de, pt)

    this.switchUserAccessStateForm = this.formBuilder.group({
      userId: ['', [Validators.required]],
      block: [false, [Validators.required]],
    })

    this.addAdminForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['',[Validators.required,Validators.email]],
      phoneNumber: ['',[Validators.required,Validators.pattern(/^\d+$/)]],
      password: ['',[Validators.required,this.passwordValidator()]],
      confirmPassword: ['',[Validators.required,this.passwordMatchValidator]],
      userRole: ['',[Validators.required]],
    })
  }

  passwordMatchValidator(control: any) {
    const password = control?.parent?.get('password')?.value;
    const confirmPassword = control?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  ngOnInit() {
    document.getElementById('الرئيسية')?.classList.remove('active')
    document.getElementById('الفعاليات')?.classList.remove('active')
    document.getElementById('المشرفين')?.classList.remove('active')
    document.getElementById('المستخدمين')?.classList.remove('active')
    document.getElementById('فئات المناسبات')?.classList.remove('active')
    // document.getElementById('الإشعارات')?.classList.remove('active')
    document.getElementById('العروض')?.classList.remove('active')
    
    this.columns = [
      {
        prop: 'selected',
        name: '',
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizable: false,
        headerCheckboxable: true,
        checkboxable: true,
        width: 50
      },
      { prop: '#' },
      { prop: 'name', name: 'اسم المستخدم' },
      { prop: 'email', name: 'البريد الإلكترونى' },
      { prop: 'phoneNumber', name: 'رقم الهاتف' },
      { prop: 'role', name: 'الصلاحيات' },
      { prop: 'isActive', name: 'حالة الحساب' },
      { prop: '' },
    ]
    this.api.showAllAdmin(1,100).subscribe({
      next: (response: ApiResponse<AdminUserDto[]>) => {
        console.log(response.data)
        this.rows = response.data.map( (item: AdminUserDto, index: number) => ({
          id: item.id,
          '#': index + 1,
          name: item.name,
          email: item.email,
          phoneNumber: item.phoneNumber,
          isActive: item.isActive,
          role: item.role
        }))
        this.temp = [...this.rows]
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })

    this.contentHeader = {
      headerTitle: 'المسئولين',
      actionButton: false
    }
  }
  
  // table
  public readonly pageLimitOptions = [
    {value: 5},
    {value: 10},
    {value: 25},
    {value: 50},
    {value: 100},
  ];
  public chkBoxSelected: AdminRow[] = [];
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  rows: AdminRow[] = [];
  temp: AdminRow[] = [];
  @ViewChild(DatatableComponent) public table!: DatatableComponent;
  ColumnMode = ColumnMode;
  columns: any[] = [];
  customChkboxOnSelect({ selected }: { selected: AdminRow[] }) {
    this.chkBoxSelected.splice(0, this.chkBoxSelected.length);
    this.chkBoxSelected.push(...selected);
  }
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : '';

    // Filter data by checking all columns
    const temp = this.temp.filter((row: AdminRow) => {
      return Object.keys(row).some((key) => 
        (row as any)[key]?.toString().toLowerCase().includes(val)
      );
    });

    // Update the rows
    this.rows = temp;
    console.log(temp)
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    if (this.table) {
      this.table.limit = this.currentPageLimit;
      this.table.recalculate();
      setTimeout(() => {
        if (this.table && this.table.bodyComponent && this.table.bodyComponent.temp && this.table.bodyComponent.temp.length <= 0) {
          this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
        }
      });
    }
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }

  // modal
  modalOpenDefault(modalDefault: any) {
    this.modalService.open(modalDefault, {
      centered: true
    });
  }
  modalOpenLG(modalLG: any) {
    this.modalService.open(modalLG, {
      centered: true,
      size: 'lg'
    });
  }

  deletedItemId: any
  deleteItem(id: number) {
    console.log("Deleted Item ID:", id);
    this.deletedItemId = id; // Store ID for further actions
  }

  confirmDelete(){
    if(this.deletedItemId){
      this.api.deleteAdmin(this.deletedItemId).subscribe({
        next: (response: ApiResponse<any>) => {
          if(response.success == true){
            console.log(response)
            this.toastService.show('تم الحذف بنجاح ✅');
            setTimeout(() => {
              window.location.reload()
            }, 2000);
          }
        }, error: (error: HttpErrorResponse) => {
          this.toastService.show('خطأ أثناء الحذف ❌');
        }
      })
    }
  }

  edit(){
    const data = {
      adminOrAssistantId: this.adminOrAssistantId,
      userName: this.addAdminForm.value.name,
      email: this.addAdminForm.value.email,
      phoneNumber: this.addAdminForm.value.phoneNumber,
      password: this.addAdminForm.value.password,
    }
    if(data){
      this.api.editAdmin(data).subscribe({
        next: (response: ApiResponse<any>) => {
          if(response.success == true){
            console.log(response)
            this.toastService.show('تم التعديل بنجاح ✅');
            this.modalService.dismissAll();
            setTimeout(() => {
              window.location.reload()
            }, 2000);
          }
        }, error: (error: HttpErrorResponse) => {
          this.toastService.show(error.error.message);
        }
      })
    }
  }

  // download files
  downloadFile(file: string){
    if(file == 'pdf'){
      let tableHTML = `
        <html>
          <head>
            <title>Table Export</title>
            <style>
              table { width: 100%; border-collapse: collapse; font-size: 14px; direction: rtl; }
              th, td { border: 1px solid black; padding: 8px; text-align: center; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h2 style="text-align:center;">تقرير طلبات المشرفين</h2>
            <table>
              <thead>
                <tr>
                  ${Object.keys(this.rows[0]).map(header => `<th>${header}</th>`).join("")}
                </tr>
              </thead>
              <tbody>
                ${this.rows.map(row => `
                  <tr>
                    ${Object.keys(row).map(key => `<td>${row[key].toString().replace(/<[^>]*>/g, '')}</td>`).join("")}
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </body>
        </html>
      `;

      const newWindow = window.open("", "_blank");
      newWindow?.document.write(tableHTML);
      newWindow?.document.close();
      newWindow?.print();
    }else if(file == 'excel'){
      if (!this.rows || this.rows.length === 0) {
        alert("لا توجد بيانات للتصدير!");
        return;
      }
    
      let csvContent = "\uFEFF"; // UTF-8 BOM for Arabic compatibility
    
      // Extract column headers dynamically from the first row
      const headers = Object.keys(this.rows[0]); 
      csvContent += headers.join(",") + "\n";
    
      // Add Table Rows
      this.rows.forEach(row => {
        const rowData = headers.map(header => {
          let cell = row[header] ? row[header].toString() : '';
          return `"${cell.replace(/"/g, '""').replace(/<[^>]*>/g, '')}"`; // Escape quotes & remove HTML
        }).join(",");
        csvContent += rowData + "\n";
      });
    
      // Create a Download Link
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "admins.csv");
      document.body.appendChild(link);
    
      // Trigger Click
      link.click();
      document.body.removeChild(link);
    }
  }

  specificAdmin: any
  adminOrAssistantId: string = ''
  showSpecificAdmin(id: string){
    console.log(id)
    this.specificAdmin = this.rows.filter( (item: AdminRow) => item.id == id)
    console.log(this.specificAdmin)
  }

  blockOrActive(id: any, isActive: any){
    console.log(isActive)
    const block = !isActive;
    console.log(block)
    if(id){
      this.switchUserAccessStateForm.patchValue({
        userId: id,
        block: !block
      })
    }
  }

  confirmBlockOrActive(){
    if(this.switchUserAccessStateForm.valid){
      this.api.switchUserAccessState(this.switchUserAccessStateForm.value).subscribe({
        next: (response: ApiResponse<any>) => {
          if(response.success == true){
            console.log(response)
            this.toastService.show('تم تغيير حالة الحساب بنجاح ✅');
            setTimeout(() => {
              window.location.reload()
            }, 2000);
          }
        }, error: (error: HttpErrorResponse) => {
          this.toastService.show('فعالية خطأ أثناء تغيير حالة الحساب ❌');
        }
      })
    }
  }

  get f(){
    return this.addAdminForm.controls;
  }

  save(){
    this.addAdminForm.markAllAsTouched();
    console.log(this.addAdminForm.value)
    if(this.addAdminForm.valid){
      console.log(this.addAdminForm.value)
      this.api.addAdmin(this.addAdminForm.value).subscribe({
        next: (response: ApiResponse<any>) => {
          if(response.success == true){
            console.log(response)
            this.toastService.show('تم إضافة الحساب بنجاح ✅');
            this.modalService.dismissAll();
            // modal.close('Accept click')
            setTimeout(() => {
              window.location.reload()
            }, 2000);
          }
        }, error: (error: HttpErrorResponse) => {
          this.toastService.show(error.error.message);
        }
      })
    }
  }

  dataToEdit?: AdminDetailDto
  loadFormData(id: string){
    this.adminOrAssistantId = id
    if(id){
      this.api.showAdmin(id).subscribe({
        next: (response: ApiResponse<AdminDetailDto>) => {
          this.dataToEdit = response.data
          if (this.dataToEdit) {
            this.addAdminForm.patchValue({
              name: this.dataToEdit.userName,
              email: this.dataToEdit.email,
              phoneNumber: this.dataToEdit.phoneNumber,
              role: this.dataToEdit.role,
            })
          }
        },error: (error: HttpErrorResponse) => {

        }
      })
    }
  }

  reset(){
    this.addAdminForm.patchValue({
      name: '',
      email: '',
      phoneNumber: '',
      password: '',
      confirmPassword: '',
    })
    // console.log(this.eventCatForm.value)
  }
  passwordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null; // skip validation if empty
      }

      const value = control.value;
      const errors: any = {};

      // 1. Minimum length 8 characters
      if (value.length < 8) {
        errors.minLength = { requiredLength: 8, actualLength: value.length };
      }

      // 2. At least 1 uppercase letter
      if (!/[A-Z]/.test(value)) {
        errors.missingUppercase = true;
      }

      // 3. At least 1 lowercase letter
      if (!/[a-z]/.test(value)) {
        errors.missingLowercase = true;
      }

      // 4. At least 1 number
      if (!/[0-9]/.test(value)) {
        errors.missingNumber = true;
      }

      // 5. At least 1 symbol (special character)
      if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value)) {
        errors.missingSymbol = true;
      }

      // Return null if no errors, otherwise return the errors object
      return Object.keys(errors).length ? { passwordRequirements: errors } : null;
    };
  }
}


/*
can make inactive for the organizer
page for assign organizer to the event (i can assign organizer for multiple events and can make assign envents to multiple organizers)
*/